import { ArrowsRightLeftIcon } from "@heroicons/react/16/solid";
import React from "react";
import { useNavigate } from "react-router";
import { OverflowFrame } from "./OverflowFrame";
import { PageHeading } from "./PageHeading";
import { Link } from "./tailwind/link";
import { Text } from "./tailwind/text";

export function StartCampaignOrAutomationPage({ hasAutomations = false }) {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const nextPage = urlParams.get("next_page") ?? "";
  const classLink =
    "hover:cursor-pointer w-80 h-80 p-3 border rounded-customBorderRadius shadow-shadowbuttonmin hover:shadow-shadowbuttonpink flex flex-col justify-center items-center";
  const classTitle = "text-xl text-center";
  const classText = "text-base text-center";
  const automationNames = {
    "abandoned-cart": "abandon checkout",
    "order-confirmation": "order paid",
    "order-tracking": "order shipped",
    "back-in-stock": "back in stock",
    "optin-confirmation": "optin confirmation",
    klaviyo: "flow webhook",
    api: "API",
  };
  return (
    <>
      <PageHeading
        title={
          hasAutomations
            ? `Create ${automationNames[nextPage]} automation`
            : "Create new campaign"
        }
      />
      <OverflowFrame>
        <div className="flex flex-col max-w-[1024px] justify-evenly items-center m-auto h-full md:flex-row p-5 md:p-0">
          <Link
            className={classLink}
            onClick={
              hasAutomations
                ? () => navigate(`/automations/new/${nextPage}`)
                : () => navigate("/campaigns/new/template")
            }
          >
            <div>
              <Text className={classTitle}>Existing WhatsApp template</Text>
              <Text className={classText}>Select a first message</Text>
            </div>
          </Link>
          <ArrowsRightLeftIcon className="h-20 text-zinc-500 rotate-90 md:rotate-0" />
          <Link
            className={classLink}
            onClick={
              hasAutomations
                ? () => navigate(`/templates/new?next_page=${nextPage}`)
                : () => navigate("/templates/new")
            }
          >
            <Text className={classTitle}>New WhatsApp template</Text>
            <Text className={classText}>Create the first message</Text>
          </Link>
        </div>
        <div className="mx-auto flex w-full max-w-7xl items-start py-5 gap-x-8"></div>
      </OverflowFrame>
    </>
  );
}
